import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getTopPerformingAssetsByImpressions } from "../../assets/api/asset";
import AnimatedNumber from "../../common/components/AnimatedNumber";
import { toast } from "../../common/components/Toast";
import { SPACING } from "../../common/constants/spacing";

export const TopPerfomingContentByImpressions = () => {
  const { t } = useTranslation("analytics");
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const fetchTopPerformingAssets = async () => {
      try {
        const fetchedAssets = await getTopPerformingAssetsByImpressions();
        setAssets(fetchedAssets);
      } catch (error) {
        toast.error(error.message || "Failed to fetch analytics");
      }
    };

    fetchTopPerformingAssets();
  }, []);

  return (
    <Box>
      <Typography variant="h3" fontWeight="bold" sx={{ mt: 4, mb: SPACING.sm }}>
        {t("topPerformingContent.byImpressions")}
      </Typography>
      {!assets || assets.length === 0 ? (
        <Card sx={{ p: 3 }} variant="outlined">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 4,
            }}
          >
            <Typography variant="bodyMd" sx={{ color: "text.secondary" }}>
              {t("topPerformingContent.noDataImpressions")}
            </Typography>
          </Box>
        </Card>
      ) : (
        <Card sx={{ p: 0, mb: 5 }} variant="outlined">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Rank
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Title
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="subtitle2" fontWeight="bold">
                      Impressions
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assets.map((asset, index) => (
                    <TableRow key={asset.id} hover>
                      <TableCell>
                        <Typography variant="bodySm" fontWeight="medium">
                          {index + 1}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="bodySm">{asset.title}</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="bodySm">
                          <AnimatedNumber
                            section="tables"
                            value={asset.total_impressions || 0}
                          />
                        </Typography>
                      </TableCell>
                    </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}
    </Box>
  );
};
